import React from 'react';
import { observable } from 'mobx';
import { observer, Provider } from 'mobx-react';
import { withRouter } from 'react-router-dom';

import { Button, Loader, Popconfirm } from '@smartplatform/ui';
import ImportStore from './store';
import DateSelect from './DateSelect';
import Questions from './Questions';
import Updates from './Updates';
import './style.scss';

@withRouter @observer
export default class PlenarySessionImport extends React.Component {

	constructor(props) {
		super(props);
		this.store = new ImportStore();
		const id = parseInt(this.props.match.params.id);
		this.isAdmin = store.model.roles ? store.model.roles.findIndex(role => role.name === 'admin') !== -1 : false;
		if (id) {
			this.store.init(id);
		}
		else {
			this.store.error = 'Нет ID';
		}
	}
	
	render() {
		const { plenarySession, session, isLoading, error, importInProgress } = this.store;
		
		if (isLoading) return '...';
		if (error) return <div className="error">{error}</div>;
		
		return <Provider store={this.store}>
			<div className="session-import">
				<div className="name block">{plenarySession.name}</div>
				<div className="session-status">
					{!session ?
						<div>
							<div className="hint">Сначала необходимо импортировать сессию и вопросы из epz.iltumen.ru.</div>
							{importInProgress ?
								<><Loader size={18}/> Импорт...</>
								:
								<Button className="btn-primary" onClick={this.store.createSession}>Импорт из epz.iltumen.ru</Button>
							}
						</div>
						:
						<div>
							<div className="session-import-status">
								Сессия импортирована из epz.iltumen.ru
								<div style={{ marginTop: 5}}>
									<Popconfirm content="Удалить?" onConfirm={this.store.deleteSession}>
										<Button className="btn-danger btn-xs">Удалить сессию и вопросы</Button>
									</Popconfirm>
								</div>
							</div>
							<Updates />
							<DateSelect />
							<Questions />
						</div>
					}
				</div>
			</div>
		</Provider>;
	}
	
}

